 const URL = "https://backend-server4.herokuapp.com/"
// const URL = "http://localhost:3001/"
export default {
    baseURL: URL,
    adminURL: URL + "api/server/admin/"

}
